import styled from 'styled-components';

/** ISO/IEC 7810 ID-1 card aspect ratio (~1.586:1). */
const cardHeight = (width: number) => Math.round(width / 1.586);

export const IconFrame = styled.span<{ $width?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width = 44 }) => $width}px;
  height: ${({ $width = 44 }) => cardHeight($width)}px;
  flex-shrink: 0;
  border-radius: 7px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05),
    0 4px 10px rgba(15, 23, 42, 0.06);
  overflow: hidden;

  svg,
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
  }
`;
